import NewContainer from "../../../../components/@repositories/containers/NewContainer";

import { routeTypes } from "../../../../../../hooks/useSystemRoutes"

export default function ContainerNewPage() {

    return (
        <NewContainer 
            routeType={routeTypes.admin}
        />
    )
}